import { getOhCookie } from '../../../../shared/cookie';
import { addShells } from '../../../../shared/redis';
// import { getAmplitude } from '../../../../shared/analytics';
// import { toDayFormat } from '../../../../shared';
// import { timeInMs } from '../../../../shared';
// import { trackAmplitudeEvent } from '../../../../shared/analytics';
// import { getAmplitudeUserProperties } from '../../../../shared/analytics/utils';
import storage from '../../../../shared/storage';
import { GlobalState } from '../../../types.global';

// const getWebAppExperimentName = async () => {
//   try {
//     const webappExtension = await getOhCookie('experiment');
//     if (!webappExtension) return '';
//     const experiment = JSON.parse(webappExtension);
//     return experiment && experiment.scenario ? experiment.scenario.name : '';
//   } catch (err) {
//     return '';
//   }
// };

// export const trackRetention = (state: GlobalState): boolean => {
//   const { installationDate, lastTrackRetention } = state.user;

//   // Theory: there is a data format that makes Date invalid
//   const now = Date.now();
//   const lastTrackRetentionDate = lastTrackRetention
//     ? new Date(lastTrackRetention)
//     : 0;
//   const installation = Number(new Date(installationDate));

//   const countedDays = Math.floor((now - installation) / timeInMs.day);

//   // if (countedDays <= 0) return false;

//   const ongoingDays = new Array(countedDays)
//     .fill('')
//     .map((v, i) => (i + 1) * 30);

//   [0, 1, 3, 7, 10, 20, ...ongoingDays]
//     .map((day) => ({
//       when: installation + day * timeInMs.day,
//       value: day,
//     }))
//     .filter((event) => event.when <= now)
//     .filter((event) => event.when > lastTrackRetentionDate)
//     .forEach((event) => {
//       trackAmplitudeEvent(
//         `Retention day ${event.value}`,
//         {
//           category: 'Retention',
//         },
//         state
//       );
//     });

//   return true;
// };

export const trackPageView = async (
  getState: () => GlobalState
): Promise<string> => {
  // const webappExperiment = await getWebAppExperimentName();

  const state = getState();
  const experiment = state.user.experiment.value;
  // const extensionExperimentName = experiment.scenario.name || '';
  // const fullExperimentName = [webappExperiment, extensionExperimentName]
  //   .filter(Boolean)
  //   .join('|');

  const experimentId = `${experiment.experimentId}:${experiment.scenario.id}`;

  // return getAmplitude<string>(async (amplitude) => {
  // const instance = amplitude.getInstance();
  // instance.setUserId(state.user.userId);

  // const userProperties = await getAmplitudeUserProperties(state);

  // const abTests = fullExperimentName.split('|').filter(Boolean);
  // instance.setUserProperties({
  //   ...userProperties,
  //   Name_of_ab_test: abTests,
  // });

  // Extension_installed lower/upper case
  // const identify = new amplitude.Identify()
  //   .setOnce(
  //     'Attribution_of_install',
  //     state.user.isInvited ? 'referral' : 'organic'
  //   )
  //   .setOnce(
  //     'Installation_date',
  //     toDayFormat(state.user.installationDate).split('-').join('')
  //   );
  // instance.identify(identify);

  // if (
  //   state.user.ntpVisitCounter === 1 &&
  //   process.env.APP_PLATFORM === 'web'
  // ) {
  //   instance.logEvent('Extension_Installed', {
  //     category: 'Extension',
  //   });
  // }

  if (state.user.ntpVisitCounter === 2) {
    // instance.logEvent('Opened_ntp_at_least_2_times', {
    //   category: 'Onboarding',
    // });

    void (async () => {
      const [clickId, campaignId] = await Promise.all([
        getOhCookie('clickId'),
        getOhCookie('campaignId'),
      ]);

      const APP_URL = process.env.APP_URL;
      await fetch(`${APP_URL}/api/track`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          userId: state.user.userId,
          event: 'Opened_ntp_at_least_2_times',
          clickId,
          campaignId,
        }),
      });
    })();
  }

  if (state.user.ntpVisitCounter === 2) {
    const click_id = await getOhCookie('click_id');
    try {
      await fetch(`https://p.oceanhero.today/?click_id=${click_id}`);
    } catch (err) {
      console.error(err);
    }
  }

  if (state.user.isFirstTimeToday) {
    // Opened_tab_first_time_today
    addShells(state.user.shells?.trackingBufferPrev || 0);
    //   instance.logEvent('Opened_tab_first_time_today', {
    //     category: 'Active user ntp',
    //     shells_value: state.user.shells?.trackingBufferPrev || 0,
    //   });
  }

  // const delayedEvents = storage.getJSON('delayedEvents') || [];

  // delayedEvents.forEach(({ variant, payload }) => {
  // if (variant === 'event') {
  // instance.logEvent(payload[0], payload[1]);
  // } else if (variant === 'revenue') {
  // instance.logRevenueV2(
  //   new instance.Revenue()
  //     .setProductId(payload[1].productId)
  //     .setPrice(payload[1].price)
  //     .setQuantity(payload[1].quantity || 1)
  //     .setEventProperties({ category: payload[1].category })
  // );
  // }
  // });

  storage.removeItem('delayedEvents');

  return experimentId;
  // });
};
